import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@mui/styles';

import EditNotification from './../edit/EditNotification';
import Dialog from './Dialog';

class DialogEditNotification extends React.Component {

  constructor (props) {
    super(props);
    this._isMounted = false; // isMounted React pattern to avoid memory leaks
    this.state = {
      title: '',
    }
  }

  componentDidMount () {
    this._isMounted = true;
    const { notification } = this.props;
    if (notification && notification !== null) {
      this._isMounted && this.setState({
        title: "Modifier une notification",
      });
    } else {
      // nouvelle commande
      this._isMounted && this.setState({
        title: "Nouvelle notification",
      });
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  render () {
    const { classes, open, onClose, fullScreen, keepMounted, id, ...others } = this.props;
    return (
      <Dialog
        keepMounted={keepMounted}
        id={id}
        fullScreen={fullScreen}
        open={open}
        onClose={onClose}
        title={this.state.title}
      >
        <EditNotification
          scrollableTarget={id}
          hideTitle={true}
          fixedCtrl={true}
          {...others}
        />
      </Dialog>
    )
  }
}

const styles = theme => ({});

DialogEditNotification.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
};

export default withStyles(styles, { withTheme: true })(DialogEditNotification);
